// src/routes/auth.ts
import React from 'react';
import SignIn from '../pages/auth/SignIn';
import CreateAccount from '../pages/auth/CreateAccount';
import ForgetPassword from '../pages/auth/ForgetPassword';
import OptPage from '../pages/auth/OptPage';
import LoggedMiddleware from '../middleware/GuestMiddleware';
import Home from '@/pages/guest/Home/Home';
import ResetPassword from '@/pages/auth/ResetPassword';

const auth_routes: Record<string, React.ComponentType> = {
  '/login': () => (
    <LoggedMiddleware>
      <SignIn />
    </LoggedMiddleware>
  ),
  '/': () => (
    <LoggedMiddleware>
      <Home />
    </LoggedMiddleware>
  ),
  '/create-account': () => (
    <LoggedMiddleware>
      <CreateAccount />
    </LoggedMiddleware>
  ),
  '/forgot-password': () => (
    <LoggedMiddleware>
      <ForgetPassword />
    </LoggedMiddleware>
  ),
  '/get-opt': () => (
    <LoggedMiddleware>
      <OptPage />
    </LoggedMiddleware>
  ),
  '/reset-password': () => (
    <LoggedMiddleware>
      <ResetPassword />
    </LoggedMiddleware>
  ),
  'auth/verify-email/:activation_token': React.lazy(
    () => import('../pages/auth/VerifyEmail'),
  ),
  'verify-invite/:email': React.lazy(
    () => import('../pages/auth/VerifyInvite'),
  ),
  'welcome': React.lazy(
    () => import('../pages/auth/WelcomePage'),
  ),
  // BINGEPLAY-MCP-V1: public MCP landing page — no auth wrapper. This
  // is where every Astra reel + signup email lands the visitor.
  'mcp': React.lazy(
    () => import('../pages/guest/McpLanding/McpLanding'),
  ),
  // BINGEPLAY-MCP-OAUTH-V1: OAuth consent screen — public (handles
  // its own "not-logged-in → /login?next=..." bounce).
  'oauth/consent': React.lazy(
    () => import('../pages/guest/OAuthConsent/OAuthConsent'),
  ),
  // BINGEPLAY-LEGAL-V1: privacy + terms — required public URLs for
  // Anthropic + OpenAI marketplace submission.
  'legal/privacy': React.lazy(
    () => import('../pages/guest/Legal/Privacy'),
  ),
  'legal/terms': React.lazy(
    () => import('../pages/guest/Legal/Terms'),
  ),
  // BINGEPLAY-SUPPORT-V1: public support page for connector marketplace
  // submissions (OpenAI + Anthropic both require a public HTTPS support URL).
  'support': React.lazy(
    () => import('../pages/guest/Support/Support'),
  ),

};

export default auth_routes;
